const eventBack = async function () {
    if ( document.querySelector('.btn-event-back') ) {
        document.querySelector('.btn-event-back').addEventListener('click', (e) => {
            if (document.referrer.indexOf("whats-on") > -1) {
                e.preventDefault();
                history.back();
            }
        })
    }
}

export const init = eventBack;